
//#region src/errors.ts
var PrismicError = class extends Error {
	url;
	response;
	constructor(message = "An invalid API response was returned", url, response) {
		super(message);
		this.url = url;
		this.response = response;
	}
};
var ForbiddenError = class extends PrismicError {};
var NotFoundError = class extends PrismicError {};
var RepositoryNotFoundError = class extends NotFoundError {};
var ParsingError = class extends PrismicError {};
var InvalidDataError = class extends PrismicError {};
var RefExpiredError = class extends ForbiddenError {};
var RefNotFoundError = class extends ForbiddenError {};
var PreviewTokenExpiredError = class extends ForbiddenError {};

//#endregion
exports.ForbiddenError = ForbiddenError;
exports.InvalidDataError = InvalidDataError;
exports.NotFoundError = NotFoundError;
exports.ParsingError = ParsingError;
exports.PreviewTokenExpiredError = PreviewTokenExpiredError;
exports.PrismicError = PrismicError;
exports.RefExpiredError = RefExpiredError;
exports.RefNotFoundError = RefNotFoundError;
exports.RepositoryNotFoundError = RepositoryNotFoundError;
//# sourceMappingURL=errors.cjs.map